import React from 'react';
import S from './Breadcrumb.styles';
const Breadcrumb = ({ items }) => {
    return (React.createElement(S.Container, { "aria-label": "Breadcrumb" },
        React.createElement(S.List, null, items.map((item, i) => (React.createElement(S.Item, { key: item.id }, item.url ? (items.length - 1 !== i ?
            React.createElement(S.Link, { href: item.url, target: item.target, "aria-label": item.accessibleText }, item.text)
            :
                React.createElement(S.Link, { as: "span" }, item.text)) : (React.createElement(S.Link, { as: "span" }, item.text))))))));
};
export default Breadcrumb;
